import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { BaseText, Separator, RichText } from '@components';
import { Tutorial } from '@models/Tutorials/TutorialModel';
import { IS_WEB } from '@utils';

const Title = styled(BaseText)({
  color: '$heading800',
  variant: IS_WEB ? 'text.xbig' : 'text.xxlarge',
  fontWeight: 'semi',
});

const Description = styled(RichText)({
  color: '$text400',
  variant: 'text.medium',
});

export interface ITutorialDescriptionProps {
  tutorial: Tutorial;
}

export const TutorialDescription =
  observer<ITutorialDescriptionProps>(({ tutorial }) => {
    return (
      <View>
        <Title>{tutorial.title}</Title>
        <Separator size={['$4', '$5']} />
        <Description>{tutorial.description}</Description>
      </View>
    );
  });
